enum DocumentType {
  Text = "text",
  Image = "image",
  Audio = "audio",
  Record = "record",
  File = "file",
  Code = "code"
}

class Document {
  public URI: string;

  public IndexedAt: Date;
  public Date: Date;

  public SourceID: number;
  public Data: any;
  public Type: DocumentType;

  constructor(
    uri: string,
    sourceID: number,
    data: any,
    type: DocumentType,
    indexedAtStr: string,
    dateStr: string
  ) {
    this.Data = data;
    this.URI = uri;
    this.SourceID = sourceID;
    this.Type = type;

    this.IndexedAt = new Date(indexedAtStr);
    this.Date = new Date(dateStr);

    this.getAttribute = this.getAttribute.bind(this);
    this.hasAttribute = this.hasAttribute.bind(this);
  }

  public hasAttribute(attr: string): boolean {
    const v = this.getAttribute(attr);
    return v !== null && v !== undefined;
  }

  public getAttribute(attr: string): any {
    return this.Data[attr];
  }
}

export default Document;



// WEBPACK FOOTER //
// ./src/models/document.ts